import React from 'react';
import { Link } from 'react-router-dom';

const ServicesSection = () => {
    return (
        <section className="serviceSection padd-30">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="commanHead">
                            <h2>Services</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 wow bounceInLeft" data-wow-delay="0.6s">
                        <div className="container1">
                            <img src="../../assets/images/service-1.jpg" alt="Infrastructure & Facilities In Our Plant" title="Infrastructure & Facilities In Our Plant" />
                            <div className="overlay">
                                <div className="text">
                                    <h3>Infrastructure & Facilities In Our Plant</h3>
                                    <ul>
                                        <li>Transit Mixers and Chassis mounted Line Pumps to ensure proper transportation and easy pumping.</li>
                                        <li>Fully automated Ready Mix Concrete.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <h4>Infrastructure & Facilities In Our Plant</h4>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 wow pulse" data-wow-delay="0.6s">
                        <div className="container1">
                            <img src="../../assets/images/service-2.jpg" alt="Added Value To Ready Mixed Concrete" title="Added Value To Ready Mixed Concrete" />
                            <div className="overlay">
                                <div className="text">
                                    <h3>Added Value To Ready Mixed Concrete</h3>
                                    <ul>
                                        <li>Convenient, Comfortable and Economical</li>
                                        <li>Tested and Trusted Concrete</li>
                                        <li>Water Cement ratio maintained at any cost</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <h4>Added Value To Ready Mixed Concrete</h4>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 wow bounceInRight" data-wow-delay="0.6s">
                        <div className="container1">
                            <img src="../../assets/images/service-3.jpg" alt="Engineering Properties of Ready Mix Concrete" title="Engineering Properties of Ready Mix Concrete" />
                            <div className="overlay">
                                <div className="text">
                                    <h3>Highly Equiped Lab of Ready Mix Concrete</h3>
                                    <p>Any type of construction works requires concrete as a basic material. The concrete mixture is made up of different ingredients like cement, sand...</p>
                                </div>
                            </div>
                        </div>
                        <h4>Highly Equiped Lab of Ready Mix Concrete</h4>
                    </div>
                    <div className="col-md-12 col-sm-12 col-xs-12 text-center">
                        <Link to="/services" className="popart-btn" data-form="order-form" data-btn-type="open-form">Read More</Link>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ServicesSection;
